import create from 'zustand';
import {LOCAL_STORAGE} from "../settings";

interface AppStoreState {
    necessaryDataIsLoaded: boolean
    sidebarCollapsed: boolean
    toggleSidebarCollapsed: () => void
    setNecessaryDataIsLoaded: (dataIsLoaded:boolean) => void
}

const useAppStore = create<AppStoreState>(set => ({
    necessaryDataIsLoaded: false,
    sidebarCollapsed: false,

    toggleSidebarCollapsed: () => set(state => {
        let toggledCollapseValue = !state.sidebarCollapsed;
        localStorage.setItem(LOCAL_STORAGE.SIDEBAR_LS_KEY, toggledCollapseValue.toString());
        return {sidebarCollapsed: toggledCollapseValue};
    }),

    setNecessaryDataIsLoaded: dataIsLoaded => set({necessaryDataIsLoaded:dataIsLoaded})
}))

export default useAppStore;